<div class="custom-pt custom-container">
  @if (loadError) {
  <p role="alert">{{ loadError }}</p>
  <a routerLink="/sendout/create/select-template" [queryParams]="{ multiStore: true }">Tilbage til skabelonvalg</a>
  } @else if (isLoading || !this.sendout || !this.template) {
  <app-skeleton></app-skeleton>
  } @else {
  @if (this.sendout.status == SendoutStatus.Draft || this.sendoutState == SendoutState.New) {
  <app-main-heading-subtext headingText="Redigér udsendelse" subText="På denne side kan du redigere alle elementer af din udsendelse, så den kommer til at se ud, som du gerne vil have det. Billede, overskrift, brødtekst og meget mere. Når du laver ændringer vil du se det i visningen på højre hånd." extraClasses="activity-margin"></app-main-heading-subtext>
  } @else {
  <app-main-heading-subtext headingText="Udsendelse" extraClasses="activity-margin"></app-main-heading-subtext>
  }

  <div class="form-container">
    <form [formGroup]="sendoutForm">
      <app-main-heading extraClasses="create-template" headingText="Generelt"></app-main-heading>

      <!-- general data fields -->
      <div class="general-fields-container">
        <div class="d-flex">
          <div class="w-md-50" style="padding-right: 2em;">

            <app-date-field label="Udsendelsesdato" placeholder="Udsendelsesdato" [formGroup]="sendoutForm" controlName="sendoutDate" [minDate]="minSendoutDate" [overrideLocks]="true"></app-date-field>

            <!-- reference to selected stores go here -->

          </div>

          <div class="w-md-50" style="padding-right: 2em;">
            <app-form-field label="Udsendelsesnavn" placeholder="Udsendelsesnavn" className="login-form-field-width" [icon]="false" [formGroup]="sendoutForm" controlName="sendoutName" [enablePasteButton]="true"></app-form-field>
          </div>
        </div>
        <div>
          <div style="display: flex; flex-direction: column;">
            <app-stroked-button style="flex: 0 0 auto;" buttonText="Vælg butikker" (navLinkClicked)="selectStores()"></app-stroked-button>
            <div>
              @if(selectedStores.length == 0) {
              Ingen butikker valgt
              } @else {
              <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px;">
                @for(store of selectedStores; track store) {
                <div>
                  <small>{{store.id}}</small><br />
                  {{ store.place }}
                </div>
                }
              </div>
              }
            </div>

          </div>
        </div>

      </div>



      <app-main-heading extraClasses="create-template" headingText="Udsendelse"></app-main-heading>

      <!-- email fields -->
      <div class="d-flex flex-column-reverse flex-md-row gap-4 gap-md-0 email-details-container">
        <div class="w-md-50" style="padding-right: 2em;">
          <app-form-field label="Emnelinje" placeholder="Emnelinje" [icon]="false" [formGroup]="sendoutForm" controlName="contentSubjectLine" [enablePasteButton]="true"></app-form-field>

          <app-form-field label="Preheader" placeholder="Preheader" [icon]="false" [formGroup]="sendoutForm" controlName="contentPreheader" [enablePasteButton]="true"></app-form-field>

          <app-img-grid [formGroup]="sendoutForm" controlName="contentImageUrl" [templateImages]="template.availableImages"></app-img-grid>

          <app-form-field label="Overskrift" placeholder="Overskrift" [icon]="false" [formGroup]="sendoutForm" controlName="contentHeadline" [enablePasteButton]="true"></app-form-field>

          <app-rte-form-field label="Brødtekst" placeholder="Brødtekst" formControlName="contentBodyCopy" [maxLength]="1000" style="margin-bottom: 10px;"></app-rte-form-field>

          <app-link-form-field label="Link" placeholder="Link" [formGroup]="sendoutForm" controlName="contentCtaUrl" [enablePasteButton]="true"></app-link-form-field>

          <app-form-field label="Knap tekst" placeholder="Knap tekst" [icon]="false" [formGroup]="sendoutForm" controlName="contentCtaText" [enablePasteButton]="true"></app-form-field>

          <app-rte-form-field label="Disclaimer tekst" placeholder="Disclaimer tekst" formControlName="contentDisclaimer" [maxLength]="1000" style="margin-bottom: 10px;"></app-rte-form-field>
        </div>
        <div class="w-md-50 email-container">
          <app-email [templateName]="template.templateName" [subjectLine]="sendoutForm.get('contentSubjectLine')?.value" [preheader]="sendoutForm.get('contentPreheader')?.value" [headline]="sendoutForm.get('contentHeadline')?.value" [bodyCopy]="sendoutForm.get('contentBodyCopy')?.value" [ctaUrl]="this.sendoutForm.get('contentCtaUrl')?.value" [ctaText]="sendoutForm.get('contentCtaText')?.value" [disclaimer]="sendoutForm.get('contentDisclaimer')?.value" [contentImageUrl]="sendoutForm.get('contentImageUrl')?.value" [points]="previewPoints" [storeSignature]="previewStoreSignature"></app-email>
        </div>
      </div>

      <!-- email fields ends -->
    </form>

    <form [formGroup]="emailForm" (ngSubmit)="sendProofEmail()">
      <div class="d-flex flex-column-reverse flex-md-row gap-4 gap-md-0 email-details-container">
        <div class="w-md-50" style="padding-right: 2em;">
          <app-main-heading extraClasses="create-template mt-25" headingText="Test"></app-main-heading>
          <app-form-field label="Email adresse" placeholder="Email adresse" [icon]="false" [sendBtn]="true" [formGroup]="emailForm" controlName="email" (childEvent)="sendProofEmail()"></app-form-field>
        </div>
        <div class="w-md-50" style="padding-right: 49px;"></div>
      </div>

    </form>
  </div>

  <!-- buttons -->
  <div class="d-flex flex-column flex-md-row align-items-center justify-content-between margin-bottom margin-btn gap-3">
    <div class="d-flex gap-3 flex-column flex-md-row width-100 button-container">

      @if (sendoutState == SendoutState.Existing && sendout.status != SendoutStatus.Executing && sendout.status != SendoutStatus.Completed) {
      <app-stroked-button buttonText="Slet udsendelse" className="full-width-btn edit-email-sendout" (navLinkClicked)="sletUdsendelseClick()"></app-stroked-button>
      }
      <!-- @if (sendoutState == SendoutState.New) {
      <filled-button buttonText="Tilbage" className="back-btn width" (childEvent)="goToSelectEventPage()"></filled-button>
      } -->
    </div>

    <div class="d-flex gap-3 flex-column flex-md-row width-100 button-container">
      @if (sendout.status == SendoutStatus.AwaitingApproval || sendout.status == SendoutStatus.Approved || sendout.status == SendoutStatus.Rejected) {
      <app-stroked-button buttonText="Rediger" className="full-width-btn edit-email-sendout" (navLinkClicked)="onSendoutFormSubmit(SendoutStatus.Draft)"></app-stroked-button>

      <filled-button buttonText="Godkend" className="approval-btn margin width" [disabled]="sendout.status == SendoutStatus.Approved" (childEvent)="onSendoutFormSubmit(SendoutStatus.Approved)"></filled-button>
      } @else if (sendout.status == SendoutStatus.Draft) {
      <app-stroked-button buttonText="Gem" className="full-width-btn edit-email-sendout" [disabled]="!sendoutForm.dirty" (navLinkClicked)="onSendoutFormSubmit(SendoutStatus.Draft)"></app-stroked-button>

      <filled-button buttonText="Godkend" className="approval-btn margin width" [disabled]="!sendoutForm.valid" (childEvent)="onSendoutFormSubmit(SendoutStatus.Approved, true)"></filled-button>

      }
    </div>
  </div>

  @if (sendoutState == SendoutState.Existing) {
  <app-main-heading extraClasses="create-template" headingText="Kommentarer"></app-main-heading>
  <app-sendout-comments [sendoutId]="sendout.id"></app-sendout-comments>
  }
  }
</div>
